import applogger from '@applogger'
import clone from 'lodash/clone'

function blobLoadPostProcessor() {
  this.blobLoadPostProcessorHandlers = []

  this.register = function(handler) {
    if (typeof handler === 'function') {
      this.blobLoadPostProcessorHandlers.push(handler)
    }
  }

  this.process = function(id, blobData, context) {
    if (!this.blobLoadPostProcessorHandlers.length) {
      return Promise.resolve(blobData)
    }

    // This should call each callback in turn
    return new Promise((resolve, reject) => {
      (function __process(data, callbacks) {
        if (!callbacks.length) {
          applogger.debug(`Blob Processor complete: ${id}`)
          resolve(data)
        }
        else {
          let callback = callbacks.shift()
          return Promise.resolve(callback(data, context))
            .then(newBlobData => {
              return __process(newBlobData === undefined ? data : newBlobData, callbacks)
            })
        }
      })(blobData, clone(this.blobLoadPostProcessorHandlers))
    })
  }
}

export default blobLoadPostProcessor
